import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  TextField,
  Grid,
  IconButton,
  Tooltip,
  Box,
  Popover
} from "@mui/material";
import React, { Fragment, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";

import { CopyToClipboard } from "react-copy-to-clipboard";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import LibraryAddCheckRoundedIcon from "@mui/icons-material/LibraryAddCheckRounded";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { getSitesData } from "../../../apis/AlertGeneration";

const CBEWSL_SITE_NAME = `${process.env.REACT_APP_SITE_NAME}`;
const CBEWSL_SITE_LOCATION = `${process.env.REACT_APP_SITE_LOCATION}`;

function DisseminateModal(props) {
  const {
    isOpen,
    disseminateData,
    setOpenModal,
    handleSendSMS,
    monitoringReleases,
    setMonitoringReleases,
    setTriggers,
    triggers,
    capitalizeFirstLetter,
    lowercaseFirstLetter,
    ewiTemplates,
  } = props;

  const navigate = useNavigate();
  const [latest_triggers, setLatestTriggers] = [];
  const [message, setMessage] = useState("");
  const [originalMessage, setOriginalMessage] = useState("");
  const [copyMessage, setCopyMessage] = useState("");
  const [copyStatus, setCopyStatus] = useState(false);

  const [alertLevel, setAlertLevel] = useState("");
  const [siteLocation, setSiteLocation] = useState("");
  const [currentAlertTs, setCurrentAlertTs] = useState("");
  const [triggerSource, setTriggerSource] = useState([]);
  const [barangayRP, setBarangayRP] = useState("");
  const [communityRP, setCommunityRP] = useState("");
  const [lewcRP, setLewcRP] = useState("");
  const [municipalRP, setMunicipalRp] = useState("");
  const [provincialRp, setProvincialRp] = useState("");
  const [latestEventTriggers, setLatestEventTriggers] = useState([]);
  const [households, setHouseholds] = useState("");
  const [siteCode, setSiteCode] = useState("");

  useEffect(() => {
    if (siteCode) {
      getSitesData((results) => {
        const site = results.find((site) => site.site_code === siteCode);
        if (site) {
          setHouseholds(site.households);
        }
      });
    }
  }, [siteCode]);

  const releaseEWISms = () => {
    handleSendSMS(message);
  };

  const onCopyText = () => {
    handleSendSMS(message, true);
    setCopyStatus(true);
    setTimeout(() => setCopyStatus(false), 5000);
  };

  useEffect(() => {
    if (disseminateData) {
      const { public_alert_level } = disseminateData;
      if (public_alert_level !== 0) {
        let data_timestamp;
        let site_location;
        const {
          event,
          public_alert_symbol,
          releases,
          latest_event_triggers,
          is_onset_release,
        } = disseminateData;
        const { site } = event;
        const { barangay, municipality, province, site_code } = site;
        const { data_ts, release_time } = releases[0];
        data_timestamp = data_ts;
        if (is_onset_release) {
          const temp_release_time = release_time;
          const onset_data_ts = `${moment(data_ts).format(
            "YYYY-MM-DD"
          )} ${temp_release_time}`;
          const onset_hour = moment(data_ts).hour();
          data_timestamp = `${moment(data_ts).format(
            "YYYY-MM-DD"
          )} ${temp_release_time}`;
          if (onset_hour === 23) {
            data_timestamp = moment(onset_data_ts).add(1, "days");
          }
        }
        const { alert_level } = public_alert_symbol;

        setSiteCode(site_code);

        site_location = `Brgy. ${barangay}, ${municipality}, ${province}`;
        setSiteLocation(site_location);

        // let msg = `Alert ${alert_level} ang alert level sa ${site_location} ngayong ${moment(
        //   data_timestamp
        // )
        let final_data_ts = is_onset_release
          ? `${moment(data_timestamp).format("MMMM D, YYYY, hh:mm A")}`
          : `${moment(data_timestamp)
              .add(30, "minutes")
              .format("MMMM D, YYYY, hh:mm A")}`;
        let msg = `Alert level: ${alert_level}\nLokasyon: ${site_location}\nPetsa at oras: ${final_data_ts}`;

        setAlertLevel(`Alert level ${alert_level}`);
        setCurrentAlertTs(
          moment(data_timestamp).add(30, "minutes").format("LLL")
        );

        let temp = [...triggerSource];
        if (alert_level > 0) {
          setLatestEventTriggers(latest_event_triggers);
          latest_event_triggers.forEach((trigger) => {
            const { internal_sym, trigger_misc, info, ts } = trigger;
            const { trigger_symbol } = internal_sym;
            const { trigger_hierarchy, alert_level } = trigger_symbol;
            const { trigger_source } = trigger_hierarchy;
            let template = ewiTemplates.find(
              (e) =>
                e.alert_level === alert_level && e.trigger === trigger_source
            );
            if (trigger_source === "on demand") {
              const { on_demand } = trigger_misc;
              const { eq_id } = on_demand;
              if (eq_id) {
                template = ewiTemplates.find(
                  (e) =>
                    e.alert_level === alert_level && e.trigger === "earthquake"
                );
              } else {
                template = ewiTemplates.find(
                  (e) =>
                    e.alert_level === alert_level && e.trigger === "rainfall"
                );
              }
              const trig_source = eq_id
                ? "On-demand Earthquake"
                : "On-demand Rainfall";
              // msg += ` dahil ${lowercaseFirstLetter(template.sms_trigger_description)}`;
              msg += `\nBakit (${capitalizeFirstLetter(trig_source)}): ${
                template.sms_trigger_description
              }`;
              temp.push({
                source: capitalizeFirstLetter(trig_source),
                description: template.trigger_description,
                info,
              });
            } else {
              const trig_source =
                trigger_source === "moms"
                  ? "Landslide Features"
                  : trigger_source;
              // msg += ` dahil ${lowercaseFirstLetter(template.sms_trigger_description)}`;
              msg += `\nBakit (${capitalizeFirstLetter(trig_source)}): ${
                template.sms_trigger_description
              }`;

              temp.push({
                source: capitalizeFirstLetter(trig_source),
                description: template.trigger_description,
                info,
                latest_ts: ts,
              });
              setTriggerSource(temp);
            }
          });
        }
        const recommended_response = ewiTemplates.find(
          (e) => e.alert_level === alert_level
        );
        setBarangayRP(recommended_response.barangay_response);
        setLewcRP(recommended_response.lewc_response);
        setCommunityRP(recommended_response.community_response);
        setMunicipalRp(recommended_response.mlgu_response);
        setProvincialRp(recommended_response.plgu_response);

        // msg += ` Ang recommended response ay ang mga sumusunod: \n \nResponde (Komunidad): ${recommended_response.sms_community_response}\n`;
        msg += `\n\nResponde (Komunidad): ${recommended_response.sms_community_response}\n`;
        msg += `\nResponde (LEWC): ${recommended_response.sms_lewc_response}\n`;
        msg += `\nResponde (BLGU): ${recommended_response.sms_barangay_response}\n`;
        msg += `\nSource: MDRRMO Tubungan: 09481631639 / 09853424748`;
        setMessage(msg);
        setCopyMessage(msg);
        setOriginalMessage(msg);
      } else {
        // need icheck if gagana din sa extended
        const { data_ts, public_alert_level, isRoutine, site_code } =
          disseminateData;
        const recommended_response = ewiTemplates.find(
          (e) => e.alert_level === public_alert_level
        );
        let site_location = CBEWSL_SITE_LOCATION;
        setSiteLocation(site_location);
        // let msg = `Alert ${recommended_response.alert_level} ang alert level sa ${site_location} ngayong ${moment(data_ts)
        let msg = `Alert Level: ${
          recommended_response.alert_level
        }\nLokasyon: ${site_location}\nPetsa at oras: ${moment(data_ts)
          .add(30, "minutes")
          .format("MMMM D, YYYY, h:mm A")}`;

        setAlertLevel(`Alert Level ${recommended_response.alert_level}`);
        setCurrentAlertTs(moment(data_ts).add(30, "minutes").format("LLL"));

        let temp = [...triggerSource];
        if (isRoutine === false) {
          temp.push({
            source: "Extended",
            description: recommended_response.trigger_description,
          });
        }
        setTriggerSource(temp);
        setSiteCode(site_code);
        setCommunityRP(recommended_response.community_response);
        setLewcRP(recommended_response.lewc_response);
        setBarangayRP(recommended_response.barangay_response);
        setMunicipalRp(recommended_response.mlgu_response);
        setProvincialRp(recommended_response.plgu_response);

        // msg += ` dahil ${recommended_response.trigger_description}`;
        // msg += ` dahil ${lowercaseFirstLetter(recommended_response.sms_trigger_description)}`;
        msg += `\nBakit: ${recommended_response.sms_trigger_description}`;
        // msg += ` Ang recommended response ay ang mga sumusunod: \n\nResponde (Komunidad): ${recommended_response.sms_community_response}\n\nResponde (LEWC): ${recommended_response.sms_lewc_response}\n\nResponde (BLGU): ${recommended_response.sms_barangay_response}\n\nSource: MDRRMO Tubungan: 09604200633 / (033)320-4560`;
        msg += `\n\nResponde (Komunidad): ${recommended_response.sms_community_response}\n`;
        msg += `\nResponde (LEWC): ${recommended_response.sms_lewc_response}\n`;
        msg += `\nResponde (BLGU): ${recommended_response.sms_barangay_response}\n`;
        msg += `\nSource: MDRRMO Tubungan: 09481631639 / 09853424748`;
        setMessage(msg);
        setCopyMessage(msg);
        setOriginalMessage(msg);
        console.log("hehe", recommended_response.trigger_description);
      }
    }
  }, [disseminateData]);

  const renderBulletin = () => {
    navigate(`/bulletin`, {
      replace: true,
      state: {
        alertLevel: alertLevel,
        siteLocation: siteLocation,
        currentAlertTs: currentAlertTs,
        triggerSource: triggerSource,
        barangayRP: barangayRP,
        communityRP: communityRP,
        lewcRP: lewcRP,
        municipalRP: municipalRP,
        provincialRp: provincialRp,
        triggerList: latestEventTriggers,
        households: households,
      },
    });
  };

  const sendEwiSMS = () => {
    setOpenModal(false);
    handleSendSMS(message);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [staffName, setStaffName] = useState("");
  const [addedStaffName, setAddedStaffName] = useState("");

  const handleAddStaffClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleCloseAddStaff = () => {
    setAnchorEl(null);
  };

  const openAddStaff = Boolean(anchorEl);
  const id_staff_name = openAddStaff ? "add-person-popover" : undefined;

  const handleAddName = () => {
  if (!staffName.trim()) return;
  setAddedStaffName(staffName);

  const baseMessage = originalMessage || message;

  let updatedMessage = "";
  if (/Source:.*/i.test(baseMessage)) {
    updatedMessage = baseMessage.replace(
      /Source:.*/i,
      `Source: ${staffName} from MDRRMO Tubungan - 09481631639 / 09853424748`
    );
  } else {
    updatedMessage = `${baseMessage}\nSource: ${staffName} from MDRRMO Tubungan - 09481631639 / 09853424748`;
  }

  setMessage(updatedMessage);
  setCopyMessage(updatedMessage);
  handleCloseAddStaff();
  setStaffName("");
};


  return (
    <Dialog
      fullWidth
      fullScreen={false}
      open={isOpen}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Typography variant="h5">Disseminate Warning</Typography>
            <Box display="flex" gap={1}>
              <IconButton color="primary" size="medium" onClick={handleAddStaffClick}>
                <Tooltip title="Add MDRRMO staff">
                  <PersonAddAltIcon fontSize="inherit" />
                </Tooltip>
              </IconButton>

              <Popover
                id={id_staff_name}
                open={openAddStaff}
                anchorEl={anchorEl}
                onClose={handleCloseAddStaff}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                <Box p={2} display="flex" flexDirection="column" gap={1}>
                  <TextField
                    label="Enter staff name"
                    variant="outlined"
                    size="small"
                    value={staffName}
                    onChange={(e) => setStaffName(e.target.value)}
                    autoFocus
                  />
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleAddName}
                  >
                    Add
                  </Button>
                </Box>
              </Popover>

              <CopyToClipboard text={copyMessage} onCopy={onCopyText}>
                <Tooltip
                  title={
                    copyStatus ? "EWI copied to clipboard!" : "Copy to Clipboard"
                  }
                >
                  <IconButton color="primary" size="medium">
                    {copyStatus ? (
                      <LibraryAddCheckRoundedIcon fontSize="inherit" />
                    ) : (
                      <ContentCopyRoundedIcon fontSize="inherit" />
                    )}
                  </IconButton>
                </Tooltip>
              </CopyToClipboard>
            </Box>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item md={12}>
            <TextField
              id="filled-multiline-static"
              label="Message"
              multiline
              rows={25}
              variant="filled"
              value={message}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            setAddedStaffName("");
            setMessage(originalMessage);
            setCopyMessage(originalMessage);
            setOpenModal(false)
          }}
          color="error"
        >
          Cancel
        </Button>
        {/* <Button
          variant="contained"
          onClick={() => setOpenModal(false)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            sendEwiSMS();
          }}
          color="primary"
        >
          Send EWI SMS
        </Button> */}
        <Button
          variant="contained"
          onClick={() => {
            renderBulletin();
          }}
          color="primary"
        >
          Generate Bulletin
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DisseminateModal;
